import React from 'react'
import { getMediaUrl } from '../../../../utils/utils'
import StandartIcon from '../../../../icons/standart.svg'
import PremiumIcon from '../../../../icons/premium.svg'
import { CHART_TYPES } from '../../mock'
import LazyLoad from '../LazyLoad'
import { getButtonWidth } from '../../utils'

export const StackSizes = ({
  stackSizes = [],
  selectedFilters,
  setSelectedFilters,
  config,
  userAccess,
  showAccessPopup,
  sendChartOptionSelectToAnalytics,
}) => {
  const onPress = (item) => {
    sendChartOptionSelectToAnalytics(item)

    setSelectedFilters({ ...selectedFilters, stack: item })
  }
  const { chartType } = selectedFilters
  const { huRestrictions, blindRestrictions } = config

  const buttonWidth = getButtonWidth(stackSizes.length, true)

  const getRequiredAccess = (blind) => {
    if (!chartType || !huRestrictions || !blindRestrictions) return 'free'

    const type = CHART_TYPES[chartType]
    const isHU = type.includes('_hu_')
    if (isHU) {
      return huRestrictions[type]
    }
    return blindRestrictions[blind]
  }

  const needAccess = (blind) => {
    if (userAccess === 'guest'){
      const requiredAccess = getRequiredAccess(blind)
      return requiredAccess || true;
    }
    if (userAccess === 'pcp') {
      return false
    } else {
      const requiredAccess = getRequiredAccess(blind)
      if (requiredAccess === 'pcp') {
        return 'pcp'
      } else if (requiredAccess === 'pc') {
        if (userAccess === 'pc') return false
        return 'pc'
      }
      return false
    }
  }

  const renderAccessChips = (needAccess) => {
    if (!needAccess) return null
    if (needAccess === 'pcp') {
      return (
        <div className="PreflopCharts__access-chip">
          <img
            alt=""
            className="PreflopCharts__access-chip_image"
            src={getMediaUrl(PremiumIcon)}
          />
        </div>
      )
    }

    if (needAccess === 'pc') return (
      <div className="PreflopCharts__access-chip">
        <img
          alt=""
          className="PreflopCharts__access-chip_image"
          style={{ marginRight: '-3px' }}
          src={getMediaUrl(StandartIcon)}
        />
        <img
          alt=""
          className="PreflopCharts__access-chip_image"
          src={getMediaUrl(PremiumIcon)}
        />
      </div>
    )
  }

  return (
    <div className="PreflopCharts__options">
      <p>Stack Size, bbs</p>
      <div className="PreflopCharts__options-row">
        {!stackSizes?.length ? (
          <LazyLoad />
        ) : (
          stackSizes.map((stackSize, idx) => {
            if (
              blindRestrictions &&
              blindRestrictions[stackSize] === false &&
              CHART_TYPES[selectedFilters.chartType] === 'mtts_full_ring'
            )
              return null
            const isSelected = stackSize === selectedFilters.stack
            const needsAccess = needAccess(stackSize)
            return (
              <div
                key={stackSize}
                onClick={() => {
                  if (needsAccess) {
                    showAccessPopup(needsAccess)
                    return
                  }
                  onPress(stackSize)
                }}
                className="PreflopCharts__button"
                style={{
                  maxWidth: buttonWidth,
                  minWidth: buttonWidth,
                  borderWidth: isSelected ? '2px' : 0,
                  position: 'relative',
                }}
              >
                <div
                  className="PreflopCharts__button-label"
                  style={{
                    color: isSelected ? '#0085FF' : 'black',
                  }}
                >
                  {stackSize}
                </div>
                {renderAccessChips(needsAccess)}
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
